import * as R from 'ramda'

export const getAllSurveyTypesInString = (surveysEntity) => {
  return R.compose(
    R.join(', '),
    R.uniq,
    R.map(R.prop('type')),
    R.reject(R.isNil),
    R.values
  )(surveysEntity)
}

export const getAllUtmValues = (params) => {
  return R.pick(['utm_campaign', 'utm_source', 'utm_medium', 'utm_term', 'utm_content'], params)
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/Intercom/utils.js